module.exports = __webpack_public_path__ + "img/Java.74e943d8.png";